import React from 'react';
import { useHistory } from 'react-router-dom';
import { AuthHeader } from 'components';
import Login from 'components/Auth/Login';
import { useGoogleLogin } from 'hooks/useGoogleLogin';
import Utils from 'lib/Utils';
import { routeConstants } from 'routes';
import AuthMFAVerification from './AuthMFAVerification';
import AuthTerms from './AuthTerms';

const AuthLogin: React.FC = () => {
  const history = useHistory();

  const handleGoogleLogin = useGoogleLogin({
    redirectUri: Utils.buildUrl(routeConstants.public.redirectGoogle.login),
  });

  return (
    <Login
      handleGoogleLogin={handleGoogleLogin}
      authHeader={<AuthHeader data-cy="auth-header-login" title="Welcome Back" subtitle="Log in to your Kickfin account." />}
      authTerms={<AuthTerms />}
      onForgotPasswordClick={() => history.push(routeConstants.public.resetPassword)}
      signupText="New to Kickfin? Your employer will send an invitation for you to create an account. Check your email or text messages and click on the URL when it arrives."
      renderMFAVerification={({ mfaRequired, onBack }) => <AuthMFAVerification mfaRequired={mfaRequired} onBack={onBack} />}
    />
  );
};

export default AuthLogin;
